import { render, staticRenderFns } from "./TrainStudentManage.vue?vue&type=template&id=6a948c03&scoped=true"
import script from "./TrainStudentManage.vue?vue&type=script&lang=js"
export * from "./TrainStudentManage.vue?vue&type=script&lang=js"
import style0 from "./TrainStudentManage.vue?vue&type=style&index=0&id=6a948c03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a948c03",
  null
  
)

export default component.exports